import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'El material está diseñado específicamente para docentes de educación secundaria, bachillerato, educación media, ciclo básico y ciclo diversificado de los 14 países de Latinoamérica.'
}, {
  q: '¿Sirve para cualquier país de Latinoamérica?',
  a: 'Sí. El material fue desarrollado desde cero para los 14 países de la colección con ejemplos, datos y referencias específicas de cada región. No es material genérico adaptado: es material hecho para la realidad latinoamericana.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF listo para usar directamente en el aula, proyectarlo, imprimirlo o compartirlo digitalmente con tus alumnos.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagas en tu moneda local. El importe se adapta automáticamente al país desde donde realizas la compra.'
}, {
  q: '¿Qué incluye la oferta especial?',
  a: 'Incluye el Mega Pack completo con los tomos y los bonos estratégicos más los tres tomos de la Colección Ciencias de la Tierra que son el complemento científico profundo sobre geología, hidrología, atmósfera y cosmología del planeta.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía total sin preguntas. Si no estás satisfecho te devolvemos el 100% de tu dinero.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green-dark" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-beige-light border border-dark-border/10 rounded-xl overflow-hidden" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-green-dark pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-dark/80 border-t border-dark-border/10 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}